// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__15eWh","tab":"ProcedureTabs_tab__3663X"};